/* ============================================
   AB Luxe & Co — Custom JavaScript
   ============================================ */

(function () {
  'use strict';

  /* --- Hover Image Swap (CSS-only primary, JS lazy-load preload) --- */
  function initHoverImageSwap() {
    var cards = document.querySelectorAll('.abluxe-product-card__media[data-hover-src]');
    cards.forEach(function (card) {
      var hoverSrc = card.getAttribute('data-hover-src');
      if (!hoverSrc) return;

      var preloaded = false;
      card.addEventListener('mouseenter', function () {
        if (preloaded) return;
        var img = card.querySelector('.abluxe-product-card__img--hover');
        if (img && !img.src) {
          img.src = hoverSrc;
        }
        preloaded = true;
      }, { once: true });
    });
  }

  /* --- Accordion: exclusive open (one at a time per group) --- */
  function initAccordions() {
    var groups = document.querySelectorAll('.abluxe-accordion');
    groups.forEach(function (group) {
      group.addEventListener('toggle', function (e) {
        var target = e.target;
        if (!target.classList.contains('abluxe-accordion__item')) return;
        if (!target.open) return;

        // Close other open items in this group
        var items = group.querySelectorAll('.abluxe-accordion__item[open]');
        items.forEach(function (item) {
          if (item !== target) {
            item.open = false;
          }
        });
      }, true); // capture phase to catch <details> toggle
    });
  }

  /* --- Responsive GHL iframe --- */
  function initResponsiveIframes() {
    window.addEventListener('message', function (event) {
      if (event.data && event.data.type === 'resize' && event.data.height) {
        var iframes = document.querySelectorAll('.abluxe-form-embed iframe');
        iframes.forEach(function (iframe) {
          try {
            if (event.source === iframe.contentWindow) {
              iframe.style.height = event.data.height + 'px';
            }
          } catch (e) {
            // Cross-origin; apply to all GHL iframes as fallback
            iframe.style.height = event.data.height + 'px';
          }
        });
      }
    });
  }

  /* --- Source Watch CTA: show only after user scrolls past products --- */
  function initSourceWatchCTA() {
    var cta = document.querySelector('.abluxe-source-cta');
    if (!cta) return;

    var grid = document.querySelector('.abluxe-product-grid');
    var emptyMessage = document.querySelector('.abluxe-collection-browse-section .abluxe-section');

    // If no products exist at all, show CTA immediately
    if (!grid) {
      cta.style.display = '';
      return;
    }

    // Hide initially, reveal after user scrolls past the product grid
    cta.style.opacity = '0';
    cta.style.transform = 'translateY(20px)';
    cta.style.transition = 'opacity 0.5s ease, transform 0.5s ease';

    var revealed = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !revealed) {
          revealed = true;
          cta.style.opacity = '1';
          cta.style.transform = 'translateY(0)';
          observer.disconnect();
        }
      });
    }, { threshold: 0.1 });

    observer.observe(cta);
  }

  /* --- Scroll Chevron: smooth-scroll to next section --- */
  function initScrollChevron() {
    var chevron = document.querySelector('.abluxe-hero__scroll');
    if (!chevron) return;

    chevron.addEventListener('click', function () {
      var heroSection = chevron.closest('section');
      if (!heroSection) return;
      var nextSection = heroSection.parentElement.nextElementSibling;
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  /* --- Reviews Carousel: autoplay, infinite loop, arrow nav --- */
  function initReviewsCarousel() {
    var carousel = document.querySelector('[data-reviews-carousel]');
    if (!carousel) return;

    var track = carousel.querySelector('[data-reviews-track]');
    var prevBtn = carousel.querySelector('[data-reviews-prev]');
    var nextBtn = carousel.querySelector('[data-reviews-next]');
    var slides = track.querySelectorAll('.abluxe-reviews__slide');
    if (slides.length === 0) return;

    var currentIndex = 0;
    var autoplayInterval = null;
    var autoplayDelay = 4000;

    function getSlidesVisible() {
      return window.innerWidth <= 768 ? 1 : 2;
    }

    function getSlideWidth() {
      var visible = getSlidesVisible();
      var gap = 24; // 1.5rem
      var wrapperWidth = track.parentElement.offsetWidth;
      return (wrapperWidth - gap * (visible - 1)) / visible + gap;
    }

    function goTo(index) {
      var visible = getSlidesVisible();
      var maxIndex = slides.length - visible;
      if (index > maxIndex) {
        currentIndex = 0;
      } else if (index < 0) {
        currentIndex = maxIndex;
      } else {
        currentIndex = index;
      }
      track.style.transform = 'translateX(-' + (currentIndex * getSlideWidth()) + 'px)';
    }

    function next() {
      goTo(currentIndex + 1);
    }

    function prev() {
      goTo(currentIndex - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayInterval = setInterval(next, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    nextBtn.addEventListener('click', function () {
      next();
      startAutoplay();
    });

    prevBtn.addEventListener('click', function () {
      prev();
      startAutoplay();
    });

    // Pause on hover
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    // Recalculate on resize
    window.addEventListener('resize', function () {
      goTo(currentIndex);
    });

    startAutoplay();
  }

  /* --- Product Image Magnifying Lens --- */
  function initImageZoom() {
    var container = document.querySelector('[data-abluxe-zoom]');
    if (!container) return;

    var img = container.querySelector('#abluxe-main-image');
    var lens = container.querySelector('[data-zoom-lens]');
    if (!img || !lens) return;

    var ZOOM = 2.5;
    var LENS_SIZE = 180;
    var halfLens = LENS_SIZE / 2;

    function setLensBackground() {
      var zoomSrc = img.getAttribute('data-zoom-src') || img.src;
      lens.style.backgroundImage = 'url(' + zoomSrc + ')';
    }

    // Preload the zoom image
    function preloadZoom() {
      var zoomSrc = img.getAttribute('data-zoom-src');
      if (zoomSrc) {
        var preload = new Image();
        preload.src = zoomSrc;
      }
    }

    container.addEventListener('mouseenter', function () {
      setLensBackground();
      preloadZoom();
    });

    container.addEventListener('mousemove', function (e) {
      var rect = container.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;

      // Position lens centered on cursor
      lens.style.left = (x - halfLens) + 'px';
      lens.style.top = (y - halfLens) + 'px';

      // Calculate background position for zoom effect
      var bgW = rect.width * ZOOM;
      var bgH = rect.height * ZOOM;
      var bgX = -(x * ZOOM - halfLens);
      var bgY = -(y * ZOOM - halfLens);

      lens.style.backgroundSize = bgW + 'px ' + bgH + 'px';
      lens.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
    });

    // Re-set background when thumbnail changes the main image
    var observer = new MutationObserver(function () {
      setLensBackground();
      preloadZoom();
    });
    observer.observe(img, { attributes: true, attributeFilter: ['src'] });
  }

  /* --- Debounce utility --- */
  function debounce(fn, delay) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  }

  /* --- Collection Filters: AJAX form submission --- */
  function initCollectionFilters() {
    var forms = document.querySelectorAll('[data-abluxe-filter-form]');
    if (forms.length === 0) return;

    forms.forEach(function (form) {
      form.addEventListener('change', function () {
        applyFilters(form);
      });
    });

    // Handle browser back/forward
    window.addEventListener('popstate', function () {
      fetchAndSwap(window.location.href);
    });

    // Intercept clicks on horizontal quick-filter chips → AJAX swap.
    // Avoids the "click multiple times" feel from queued full-page navigations.
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.abluxe-quick-filters__chip');
      if (!chip) return;
      // Only intercept on the collection page where AJAX swap is set up
      if (!document.getElementById('abluxe-product-results')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // allow open-in-new-tab
      var href = chip.getAttribute('href');
      if (!href) return;
      e.preventDefault();

      // Preserve sort_by and q from current URL on chip clicks
      try {
        var chipUrl = new URL(href, window.location.origin);
        var currentParams = new URLSearchParams(window.location.search);
        ['sort_by', 'q'].forEach(function (key) {
          if (!chipUrl.searchParams.has(key)) {
            var val = currentParams.get(key);
            if (val) chipUrl.searchParams.set(key, val);
          }
        });
        href = chipUrl.pathname + (chipUrl.search || '');
      } catch (err) { /* fall back to original href */ }

      history.pushState(null, '', href);
      fetchAndSwap(href);
      // Smooth scroll back to the top of the product area for context
      var top = document.getElementById('abluxe-product-results');
      if (top) {
        var rect = top.getBoundingClientRect();
        if (rect.top < 0 || rect.top > window.innerHeight) {
          window.scrollTo({ top: window.scrollY + rect.top - 120, behavior: 'smooth' });
        }
      }
    });
  }

  function applyFilters(form) {
    var params = new URLSearchParams();
    var checkboxes = form.querySelectorAll('input[type="checkbox"]:checked');
    checkboxes.forEach(function (cb) {
      params.append(cb.name, cb.value);
    });

    // Handle price range inputs
    var priceInputs = form.querySelectorAll('.abluxe-filters__price-input');
    priceInputs.forEach(function (input) {
      if (input.value) {
        params.append(input.name, input.value);
      }
    });

    // Preserve sort_by and search query (q) from current URL — toggling
    // a filter should NOT drop the user's active sort or search.
    var currentParams = new URLSearchParams(window.location.search);
    ['sort_by', 'q'].forEach(function (key) {
      var val = currentParams.get(key);
      if (val) params.append(key, val);
    });

    // Build URL from collection base path
    var basePath = window.location.pathname.split('?')[0];
    var newUrl = basePath + (params.toString() ? '?' + params.toString() : '');

    history.pushState(null, '', newUrl);
    fetchAndSwap(newUrl);
  }

  function fetchAndSwap(url) {
    var resultsContainer = document.getElementById('abluxe-product-results');
    var activeFiltersWrapper = document.getElementById('abluxe-active-filters-wrapper');
    var sidebar = document.querySelector('[data-abluxe-sidebar]');
    if (!resultsContainer) return;

    // Add loading state
    resultsContainer.style.opacity = '0.5';
    resultsContainer.style.pointerEvents = 'none';

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Swap product grid
        var newResults = doc.getElementById('abluxe-product-results');
        if (newResults) {
          resultsContainer.innerHTML = newResults.innerHTML;
        }

        // Swap active filters
        var newActiveFilters = doc.getElementById('abluxe-active-filters-wrapper');
        if (newActiveFilters && activeFiltersWrapper) {
          activeFiltersWrapper.innerHTML = newActiveFilters.innerHTML;
        }

        // Swap sidebar filters (to update counts and checked states)
        var newSidebar = doc.querySelector('[data-abluxe-sidebar]');
        if (newSidebar && sidebar) {
          sidebar.innerHTML = newSidebar.innerHTML;
          // Re-bind filter search within new sidebar
          initFilterSearch();
          // Re-bind change events on new form
          var newForm = sidebar.querySelector('[data-abluxe-filter-form]');
          if (newForm) {
            newForm.addEventListener('change', function () {
              applyFilters(newForm);
            });
          }
        }

        // Also update mobile drawer sidebar
        var drawerBody = document.querySelector('.abluxe-filter-drawer__body');
        var newDrawerSidebar = doc.querySelector('.abluxe-filter-drawer__body');
        if (drawerBody && newDrawerSidebar) {
          drawerBody.innerHTML = newDrawerSidebar.innerHTML;
          var drawerForm = drawerBody.querySelector('[data-abluxe-filter-form]');
          if (drawerForm) {
            drawerForm.addEventListener('change', function () {
              applyFilters(drawerForm);
            });
          }
          initFilterSearch();
        }

        // Update product count in toolbar
        var newToolbar = doc.querySelector('.abluxe-collection-toolbar__count');
        var toolbar = document.querySelector('.abluxe-collection-toolbar__count');
        if (newToolbar && toolbar) {
          toolbar.textContent = newToolbar.textContent;
        }

        // Swap horizontal quick-filter chips so the active one updates
        var newChips = doc.querySelector('.abluxe-quick-filters');
        var chips = document.querySelector('.abluxe-quick-filters');
        if (newChips && chips) {
          chips.innerHTML = newChips.innerHTML;
          initQuickFilters();
        }

        // Remove loading state
        resultsContainer.style.opacity = '';
        resultsContainer.style.pointerEvents = '';

        // Re-init hover image swap for new cards
        initHoverImageSwap();
      })
      .catch(function () {
        resultsContainer.style.opacity = '';
        resultsContainer.style.pointerEvents = '';
      });
  }

  /* --- Filter Search: filter checkbox items by text input --- */
  function initFilterSearch() {
    var searchInputs = document.querySelectorAll('[data-filter-search]');
    searchInputs.forEach(function (input) {
      input.addEventListener('input', debounce(function () {
        var query = input.value.toLowerCase().trim();
        var options = input.closest('.abluxe-filters__group-body').querySelectorAll('[data-filter-option]');
        options.forEach(function (option) {
          var label = option.querySelector('.abluxe-filters__option-label');
          if (!label) return;
          var text = label.textContent.toLowerCase();
          option.hidden = query.length > 0 && text.indexOf(query) === -1;
        });
      }, 150));
    });
  }

  /* --- Collection Predictive Search --- */
  function initCollectionSearch() {
    var wrapper = document.querySelector('[data-abluxe-collection-search]');
    if (!wrapper) return;

    var input = wrapper.querySelector('[data-collection-search-input]');
    var resultsContainer = wrapper.querySelector('[data-collection-search-results]');
    if (!input || !resultsContainer) return;

    var handleSearch = debounce(function () {
      var query = input.value.trim();
      if (query.length < 2) {
        resultsContainer.hidden = true;
        resultsContainer.innerHTML = '';
        return;
      }

      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6';

      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = data.resources && data.resources.results && data.resources.results.products;
          if (!products || products.length === 0) {
            resultsContainer.innerHTML = '<div class="abluxe-collection-search__no-results">No results found</div>';
            resultsContainer.hidden = false;
            return;
          }

          var html = products.map(function (product) {
            var img = product.image || '';
            var price = product.price ? '$' + (parseFloat(product.price) / 100).toLocaleString() : 'Inquire';
            if (product.price === '0.00' || product.price === '0') price = 'Inquire';
            return '<a href="' + product.url + '" class="abluxe-collection-search__result">' +
              (img ? '<img src="' + img + '" alt="" class="abluxe-collection-search__result-img" loading="lazy">' : '') +
              '<div class="abluxe-collection-search__result-info">' +
                '<p class="abluxe-collection-search__result-title">' + product.title + '</p>' +
                (product.vendor ? '<span class="abluxe-collection-search__result-vendor">' + product.vendor + '</span>' : '') +
              '</div>' +
              '<span class="abluxe-collection-search__result-price">' + price + '</span>' +
            '</a>';
          }).join('');

          resultsContainer.innerHTML = html;
          resultsContainer.hidden = false;
        })
        .catch(function () {
          resultsContainer.hidden = true;
        });
    }, 250);

    input.addEventListener('input', handleSearch);

    // Close on click outside
    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        resultsContainer.hidden = true;
      }
    });

    // Close on Escape
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        resultsContainer.hidden = true;
        input.blur();
      }
    });
  }

  /* --- Quick Filters horizontal scroll --- */
  function initQuickFilters() {
    var wrapper = document.querySelector('[data-quick-filters]');
    if (!wrapper) return;
    var track = wrapper.querySelector('[data-quick-track]');
    var prev = wrapper.querySelector('[data-quick-prev]');
    var next = wrapper.querySelector('[data-quick-next]');
    if (!track || !prev || !next) return;

    function scrollBy(dir) {
      var amount = Math.max(track.clientWidth * 0.6, 200);
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', function() { scrollBy(-1); });
    next.addEventListener('click', function() { scrollBy(1); });

    // Hide arrows when at scroll ends
    function updateArrows() {
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      prev.style.visibility = atStart ? 'hidden' : 'visible';
      next.style.visibility = atEnd ? 'hidden' : 'visible';
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  /* --- Collection Sort Dropdown --- */
  function initCollectionSort() {
    var select = document.querySelector('[data-collection-sort]');
    if (!select) return;

    select.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  }

  /* --- Mobile Filter Drawer --- */
  function initFilterDrawer() {
    var drawer = document.querySelector('[data-filter-drawer]');
    if (!drawer) return;

    var openBtns = document.querySelectorAll('[data-open-filter-drawer]');
    var closeBtns = document.querySelectorAll('[data-close-filter-drawer]');

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.showModal();
        document.body.style.overflow = 'hidden';
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.close();
        document.body.style.overflow = '';
      });
    });

    // Close on backdrop click
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) {
        drawer.close();
        document.body.style.overflow = '';
      }
    });

    // Restore scroll on close
    drawer.addEventListener('close', function () {
      document.body.style.overflow = '';
    });
  }

  /* --- Watches mega menu (hover dropdown on navbar Watches link) --- */
  function initWatchesMega() {
    var mega = document.getElementById('abluxe-watches-mega');
    if (!mega) return;
    if (window.matchMedia && window.matchMedia('(hover: none), (max-width: 1024px)').matches) return;

    // Find the Watches nav link in the visible desktop menu (not the mobile drawer).
    var header = document.querySelector('header-component, #header-group');
    if (!header) return;
    var trigger = null;
    var preferred = header.querySelectorAll('.menu-list__link, .header__menu-link, .header-menu__link, [class*="menu-list"] a');
    for (var i = 0; i < preferred.length; i++) {
      var txt = (preferred[i].textContent || '').trim().toLowerCase();
      if (txt === 'watches') {
        trigger = preferred[i];
        break;
      }
    }
    // Fallback: pick a Watches link that is currently visible
    if (!trigger) {
      var allLinks = header.querySelectorAll('a');
      for (var j = 0; j < allLinks.length; j++) {
        var t2 = (allLinks[j].textContent || '').trim().toLowerCase();
        if (t2 === 'watches' && allLinks[j].offsetParent !== null) {
          trigger = allLinks[j];
          break;
        }
      }
    }
    if (!trigger) return;

    var openTimer = null;
    var closeTimer = null;

    function open() {
      clearTimeout(closeTimer);
      mega.hidden = false;
      mega.setAttribute('aria-hidden', 'false');
      // Force reflow so the transition fires
      void mega.offsetWidth;
      mega.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      mega.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      mega.setAttribute('aria-hidden', 'true');
      // Wait for fade-out before re-hiding
      setTimeout(function () {
        if (!mega.classList.contains('is-open')) {
          mega.hidden = true;
        }
      }, 220);
    }

    function scheduleOpen() {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(open, 80);
    }

    function scheduleClose() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 180);
    }

    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('mouseenter', scheduleOpen);
    trigger.addEventListener('mouseleave', scheduleClose);
    trigger.addEventListener('focus', scheduleOpen);

    mega.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });
    mega.addEventListener('mouseleave', scheduleClose);

    // Close on escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mega.classList.contains('is-open')) {
        close();
      }
    });

    // Close when clicking outside
    document.addEventListener('click', function (e) {
      if (!mega.classList.contains('is-open')) return;
      if (mega.contains(e.target) || trigger.contains(e.target)) return;
      close();
    });
  }

  /* --- Init --- */
  function init() {
    initHoverImageSwap();
    initAccordions();
    initResponsiveIframes();
    initSourceWatchCTA();
    initScrollChevron();
    initReviewsCarousel();
    initImageZoom();
    initCollectionFilters();
    initFilterSearch();
    initCollectionSearch();
    initFilterDrawer();
    initCollectionSort();
    initQuickFilters();
    initWatchesMega();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
